import React from "react";
import Home from "../components/views/home";

const HomePage = () => {
  return (
    <>
      <Home />
    </>
  );
};

export default HomePage;
